// Canonical lists used across every TOK form for unified lead-tracking.
// Edit here, every form picks up the change.

export const TOK_INTEREST_OPTIONS = [
  "LEVEL UP",
  "Ubuntu Immersive Retreat",
  "Interactive Playground",
  "Home Education Programme",
  "XR Theatre",
  "Immersive Socials",
  "Festivals (Hip Hop / XR)",
  "Workshops",
  "Kulture Lab",
  "Corporate Experiences",
  "Wellness",
  "Memberships",
  "Family Experiences",
  "Projection Mapping",
  "AI & XR Learning",
  "Windrush Experiences",
];

export const TOK_REFERRAL_OPTIONS = [
  "Instagram",
  "TikTok",
  "YouTube",
  "Facebook",
  "WhatsApp",
  "Event / Festival",
  "Friend / Word of Mouth",
  "School / University",
  "Local Authority / Council",
  "NHS / Wellbeing Referral",
  "Google Search",
  "Press / Media",
  "Community Organisation",
  "Other",
];

/**
 * Lightweight client-side tracking context — used to enrich every form
 * submission with the page the lead was captured on + a short device
 * fingerprint (no PII; just OS / browser + screen size).
 */
export function pageSource() {
  if (typeof window === "undefined") return null;
  return `${window.location.pathname}${window.location.search || ""}`;
}

export function deviceSource() {
  if (typeof window === "undefined" || typeof navigator === "undefined")
    return null;
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const lang = navigator.language || "";
  const screen =
    typeof window !== "undefined" && window.screen
      ? `${window.screen.width}x${window.screen.height}`
      : "?";
  // Truncate UA — we just want broad analytics, not fingerprinting.
  return [platform, lang, screen, ua.slice(0, 120)].join(" · ");
}
